<!--Navbar-->
<header class="fixed-top" aria-label="Header">
  <pmd-navbar aria-label="Header" class="navbar-expand-xl pmd-z-depth-4 navbar-light bg-white">
    <div class="container-fluid">
      <pmd-navbar-brand>
        <a tabindex="0" class="navbar-brand" routerLink="/login" aria-label="Probanker Logo">
          <img
            src="assets/images/probanker-logo.svg"
            height="32"
            class="d-inline-block align-center"
            alt="Probanker Logo"
          />
        </a>
      </pmd-navbar-brand>
      <pmd-navbar-right-icon>
        <form class="ms-auto">
          <app-language></app-language>
        </form>
      </pmd-navbar-right-icon>
    </div>
  </pmd-navbar>
</header>
<!--/.Navbar-->

<!--Main Content Area-->
<main aria-label="Main Content" class="pmd-content">
  <div class="container">
    <div class="row">
      <h1 class="text-center text-primary mb-lg-3 mb-0">
        {{ 'AUTH.LOGIN.WELCOME' | translate }}
      </h1>
      <div class="col-md-12 col-lg-6 mt-3 mt-md-4">
        <router-outlet></router-outlet>
      </div>
      <div class="col-md-12 col-lg-6">
        <div class="mb-0 d-flex">
          <div class="card-body login-content-right">
            <div class="login-content">
              <div class="text-center">
                <img
                  class="mb-4 img-fluid login-content-image"
                  id="know-more-about"
                  src="assets/images/login-graphic.svg"
                  [alt]="'AUTH.LOGIN.INTRO_IMAGE' | translate"
                />
              </div>
              <h3 class="h4 mb-3">{{ 'AUTH.LOGIN.INTRO_HEADING' | translate }}</h3>
              <ul class="list-group pmd-list pmd-list-check pmd-list-transparent">
                <li
                  class="list-group-item d-flex p-0 mb-3"
                  [attr.aria-label]="'AUTH.LOGIN.PT_1' | translate"
                >
                  <i class="material-icons pmd-icon-sm me-2" aria-hidden="true">check_circle</i>
                  <span class="flex-grow-1">{{ 'AUTH.LOGIN.PT_1' | translate }}</span>
                </li>
                <li
                  class="list-group-item d-flex p-0 mb-3"
                  [attr.aria-label]="'AUTH.LOGIN.PT_2' | translate"
                >
                  <i class="material-icons pmd-icon-sm me-2" aria-hidden="true">check_circle</i>
                  <span class="flex-grow-1">{{ 'AUTH.LOGIN.PT_2' | translate }}</span>
                </li>
                <li
                  class="list-group-item d-flex p-0 mb-3"
                  [attr.aria-label]="'AUTH.LOGIN.PT_3' | translate"
                >
                  <i class="material-icons pmd-icon-sm me-2" aria-hidden="true">check_circle</i>
                  <span class="flex-grow-1">{{ 'AUTH.LOGIN.PT_3' | translate }}</span>
                </li>
                <li
                  class="list-group-item d-flex p-0 mb-3"
                  [attr.aria-label]="'AUTH.LOGIN.PT_4' | translate"
                >
                  <i class="material-icons pmd-icon-sm me-2" aria-hidden="true">check_circle</i>
                  <span class="flex-grow-1">{{ 'AUTH.LOGIN.PT_4' | translate }}</span>
                </li>
                <li
                  class="list-group-item d-flex p-0 mb-3"
                  [attr.aria-label]="'AUTH.LOGIN.PT_5' | translate"
                >
                  <i class="material-icons pmd-icon-sm me-2" aria-hidden="true">check_circle</i>
                  <span class="flex-grow-1">{{ 'AUTH.LOGIN.PT_5' | translate }}</span>
                </li>
                <li
                  class="list-group-item d-flex p-0"
                  [attr.aria-label]="'AUTH.LOGIN.PT_6' | translate"
                >
                  <i class="material-icons pmd-icon-sm me-2" aria-hidden="true">check_circle</i>
                  <span class="flex-grow-1">{{ 'AUTH.LOGIN.PT_6' | translate }}</span>
                </li>
              </ul>
              <!-- <a aria-label="Press enter to go back to the login"
                                class="know-more-link btn btn-outline-secondary btn-sm">
                                {{ 'Back to login' | translate }}
                            </a> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</main>

<footer aria-label="Footer">
  <app-footer class="login-app-footer"></app-footer>
</footer>
<!--/.Main Content Area-->
